/**
 * 导出/导入 文件格式（版本化）。
 * 故意不含 id：条目用 groupAbbr 指向分组，导入端按 abbr/date 关联并重新生成 id。
 */

export const EXPORT_VERSION = 1;

export interface ExportItem {
  content: string;
  note: string | null;
  color: string | null;
  hours: number | null;
  isDone: boolean;
  sortOrder: number;
  groupAbbr: string | null;
}

export interface ExportDayNote {
  date: string; // YYYY-MM-DD
  items: ExportItem[];
}

export interface ExportGroup {
  abbr: string;
  name: string;
  color: string | null;
  sortOrder: number;
}

export interface ExportSettings {
  theme?: string;
  showLunar?: boolean;
  showHoliday?: boolean;
  weekStart?: 0 | 1;
  maxRows?: number;
}

export interface DayNoteExport {
  app: 'daynote';
  version: number;
  exportedAt: string; // ISO 8601
  source: 'local' | 'cloud';
  data: {
    groups: ExportGroup[];
    dayNotes: ExportDayNote[];
    settings?: ExportSettings;
  };
}

/** 导入数量上限，防滥用与超大导入 */
export const IMPORT_LIMITS = {
  maxGroups: 500,
  maxDayNotes: 20000,
  maxItemsPerDay: 1000,
  maxTotalItems: 200000,
} as const;
